import React from "react";

function PlacementPolicies() {
  return (
    <div className="policy-container">
      <div className="content">
        <h2>Placement Policy</h2>
        <p>
          Techvanto Academy provides Placement assistance as a value added
          complimentary service to all students who pursue courses from
          Techvanto Academy and this service is entirely at the sole discretion
          of the Techvanto Management.
          <br />
          The purpose of the placement policy is to define the overall structure
          & processes of the Training and placement, and to structure the roles
          & responsibilities of Techvanto Academy working on this process of
          placement.
          <ul>
            <li>Maximum number of candidates get off-campus placement.</li>
            <li>
              Deserving candidates can have the opportunity to start their
              career with their preferred company.
            </li>
            <li>To maintain the quality standards of the jobs offered.</li>
            <li>
              To ensure that the whole team works according to the defined
              processes to achieve the common objective.
            </li>
          </ul>
          While Techvanto Academy assures 100% Placement Assistance, it does not
          guarantee/commit any assurance of placements/any specific number of
          interview calls for any course. Placement Assistance varies for all
          students depending upon the eligibility criteria of the recruiters and
          type of course done from Techvanto Academy and cannot guarantee any
          salary range. However, we strive to provide freshers with a package of
          at least three lakhs.
        </p>
        <p>
          <br />
          <h3>Validity of Placement Assistance</h3>
          In case requirements from the recruiters is higher than availability
          of candidates, Techvanto Academy reserves the right to deviate from
          the below mentioned eligibility criteria to meet the recruiter’s
          requirements. Techvanto Academy Qualifying Test will be conducted
          before job interviews. Preference will be given to the candidates on
          the basis of results and/or ‘Recruiter’s Criteria’. It is mandatory to
          appear for the test to appear for the ‘Job Interviews’.
        </p>
        <p>
          <br />
          <h3>Who is Eligible for Placement Assistance?</h3>
          Any candidate qualifying the conditions as mentioned; paid full course
          fees in time, holds a valid course certificate & has cleared the Test
          (Techvanto Academy Qualifying test for Placement). (Subject to
          Fulfilling eligibility criteria as specified by the recruiters)
        </p>
        <p>
          <br />
          <h3>General Qualifications for Placement Assistance</h3>
          <ul>
            <li>Successfully completed course.</li>
            <li>
              Fresher or recent Pass-outs in the last 2 academic years are
              normally preferred by the recruiters.
            </li>
            <li>
              Good academic records with no or minimum gaps in education are
              preferred.
            </li>
            <li>
              Good English Communication skills will have an added advantage.
            </li>
            <li>
              Student’s behavior and general appearance at the time of interview
              also matters.
            </li>
          </ul>
        </p>
        <p>
          <br />
          <h3>General Rules & Regulations for Placement Assistance</h3>
          <ol>
            <li>
              Classroom Training
              <br />
              We focus on different modules through live lectures, assessments,
              hands-on projects, mentorship, etc. During the whole training
              process, we closely watch the progress of the learner. We monitor
              the success by measuring their participation in the programme
              (Live + Recording) and their results in Quizzes, Tests,
              assignments and projects. A minimum cutoff score will be required
              in the programme, which will apply for placement education and
              career services, and will be expected from the applicants. We’ve
              found that candidates scoring below the minimum criterion often
              face rejections and we shall strive to get them to the minimum
              cutoff score to boost their chances at cracking the interview.
              Following the training, we will arrange 2 interviews for the
              students.
            </li>
            <li>
              Job Connect
              <br />
              Requirements in the market could include a 3-6 months initial
              internship and then get the final package. Often a job transition
              may occur within the same kit in cases of working professionals.
              <br />
              During the placements process, the Techvanto team will be 100%
              open in addressing the concerns of applicants, receiving feedback,
              etc.
              <ul>
                <li>
                  There shall be a specific deadline to apply for the Placement
                  Asisstance. Profiles of students applying after the specified
                  deadline will not be considered.
                </li>
                <li>
                  In case Techvanto Academy schedules an interview call matching
                  a candidate’s CV/educational qualification, he/she needs to
                  respect and attend the same and this will be counted as an
                  interview call.
                </li>
                <li>
                  It is the sole discretion of the recruiter to shortlist the
                  profiles sent and Techvanto Academy is not responsible for the
                  shortlisting done at recruiter’s end.
                </li>
                <li>
                  Techvanto Academy will be updating you with pan-India
                  requirements. Candidates need to broaden the locations to get
                  the maximum opportunity. If you are restricted to a particular
                  city or domain you may get fewer interview opportunities.
                </li>
                <li>
                  Placement assistance will not be provided to the candidates
                  who have not undergone Techvanto Academy evaluation processes
                  even if they are holding a ‘Course Certificate’.
                </li>
                <li>
                  Techvanto Academy & recruiters reserve the rights to set final
                  eligibility criteria and can change at any moment of time
                  without prior intimation.
                </li>
                <li>
                  Candidate’s should not contact any recruiter directly unless
                  specified by the recruiter or Techvanto Academy. In case of
                  any complaints from the recruiter against the candidate, the
                  candidate will be blacklisted permanently.
                </li>
                <li>
                  Candidate’s who have already been placed through Techvanto
                  Academy are not eligible for further ‘Placement Assistance’
                  (unless specified).
                </li>
                <li>
                  Candidate’s who have already appeared for a company in the
                  last 6-12 months are not eligible to re-apply in the same
                  company.
                </li>
                <li>
                  Candidate’s should be ready to relocate anywhere in India as
                  required by the recruiter and should be ready to work on the
                  job profile given by the recruiter.
                </li>
                <li>
                  Techvanto Academy will contact shortlisted / selected students
                  primarily through mails or SMS. In case the candidate’s are
                  not reachable due to any technical issues, Techvanto Academy
                  will not be responsible for the same.
                </li>

                <li>
                  Applicants need to attend the test / interview as per the
                  schedule given by the recruiter / Techvanto Academy as there
                  is no guarantee of the interview being rescheduled.
                </li>
                <li>
                  Before appearing for any company, it’s the applicant’s
                  responsibility to check credentials and more information about
                  the company so as to avoid any future problems like fraudulent
                  company, not good or healthy work environment etc.
                </li>
                <li>
                  If a recruiter asks to submit any original mark sheets,
                  documents, deposit, bank guarantee, copy of Passport, etc
                  while joining, the candidate needs to make a decision on his
                  own to submit the required documents and Techvanto Academy
                  will not be involved or take any responsibility for the same.
                </li>
                <li>
                  All applicants should attend placement events or meets in
                  formal attire else they will not be allowed to appear for the
                  events.
                </li>
                <li></li>
              </ul>
            </li>
          </ol>
        </p>
        <p>
          <br />
          <h3>Blacklisting Criteria for Placement Assistance</h3>
          Candidates shall be blacklisted from receiving placement assistance in
          the following conditions-
          <ul>
            <li>
              If they do not attend the interview / test as per the schedule
              given byTechvanto Academy/recruiter even after giving their
              confirmation.
            </li>
            <li>
              If they do not turn up for interviews without informing our team.
            </li>
            <li>If the candidate gets selected and rejects the offer.</li>
            <li>
              If they do not appear for the final HR round to collect the offer
              letter or for negotiation of salary.
            </li>
            <li>
              Candidates who apply even if they do not fit into the eligibility
              criteria mentioned in the mail.
            </li>
            <li>
              Candidates who provide any wrong information/fake documents/do not
              follow rules as specified.
            </li>
          </ul>
        </p>
        <p>
          <br />
          <h3>Documents To Be Carried During Interviews</h3>
          The student must be in the possession of and must produce the
          following documents at the time of placement-
          <ul>
            <li>
              Techvanto Academy Certificate (if the student has not received the
              certificate then Full fees payment receipts can be considered)
            </li>
            <li>2 Copies of Resume</li>
            <li>All mark sheets & other important original documents</li>
            <li>Valid photo ID like PAN card, Driving licence etc.</li>
            <li>2 passport size photos</li>
            <li>Passport copy (if available)</li>
          </ul>
        </p>
      </div>
    </div>
  );
}

export default PlacementPolicies;
